
import { defineComponent } from "vue";

import { ValidCategories } from "@/assets/types";

import state from "@/store/state";
import {
  showToast,
  shiftEmoji,
  randomEmojis,
  setDefault,
  saveState,
  loadState,
  clearStage
} from "@/store/methods";

import Message from "@/components/Message.vue";
import EmojiWrapper from "@/components/EmojiWrapper.vue";
import AddEmoji from "@/components/AddEmoji.vue";

export default defineComponent({
  name: "Home",
  components: {
    Message,
    EmojiWrapper,
    AddEmoji
  },
  data() {
    return {
      state: state
    };
  },
  setup() {
    function newEmoji(category: ValidCategories) {
      // console.log(category);
      shiftEmoji(state.stagingEmojis.length, category);
    }

    return {
      showToast,
      newEmoji,
      randomEmojis,
      setDefault,
      saveState,
      loadState,
      clearStage
    };
  }
});
